import { useCallback } from "react";

// hooks/useSectionFields.js
export function useSectionFields() {
    const removeFields = useCallback(({ arrayDependente = [], field_id }) => {
        if (!Array.isArray(arrayDependente)) return [];

        const isFlatArray = arrayDependente.every(item => 'id' in item);
        const idsToRemove = Array.isArray(field_id) ? field_id : [field_id];

        if (isFlatArray) {
            return arrayDependente.filter(field => !idsToRemove.includes(field.id));
        } else {
            return arrayDependente.map(item => ({
                ...item,
                fields: Array.isArray(item.fields)
                    ? item.fields.filter(field => !idsToRemove.includes(field.id))
                    : [],
            }));
        }
    }, []);

    // Atualizar propriedades de um field
    const updateField = useCallback(({ arrayDependente = [], field_id, updates = {} }) => {
        if (!Array.isArray(arrayDependente)) return [];
    
        const isFlatArray = arrayDependente.every(item => 'id' in item);
        const idsToUpdate = Array.isArray(field_id) ? field_id : [field_id];
    
        const updateFn = (field) => {
          if (idsToUpdate.includes(field.id)) {
            return { ...field, ...updates };
          }
          return field;
        };
    
        if (isFlatArray) {
          return arrayDependente.map(updateFn);
        } else {
          return arrayDependente.map(item => ({
            ...item,
            fields: Array.isArray(item.fields)
              ? item.fields.map(updateFn)
              : [],
          }));
        }
    }, []);

    // Reordena explicitamente com base na ordem do array field_id
    const sortFlatFields = useCallback(({ fields = [], field_id = [] }) => {
      if (!Array.isArray(fields)) return [];
    
      const idsToSort = Array.isArray(field_id) ? field_id : [field_id];
    
      const priorityMap = new Map(idsToSort.map((id, index) => [id, index]));
    
      return [...fields].sort((a, b) => {
        const aPriority = priorityMap.has(a.id) ? priorityMap.get(a.id) : Infinity;
        const bPriority = priorityMap.has(b.id) ? priorityMap.get(b.id) : Infinity;
        return aPriority - bPriority;
      });
    }, []);

    // Troca a ordem de dois campos
    const swapFieldOrder = useCallback(({ fields = [], field_id = [] }) => {
      if (!Array.isArray(fields) || !Array.isArray(field_id) || field_id.length < 2) return fields;
    
      const id1 = field_id[0];
      const id2 = field_id[1];
    
      const index1 = fields.findIndex(f => f.id === id1);
      const index2 = fields.findIndex(f => f.id === id2);
    
      if (index1 === -1 || index2 === -1) return fields;
    
      const newFields = [...fields];
      const temp = newFields[index1];
      newFields[index1] = newFields[index2];
      newFields[index2] = temp;
    
      return newFields;
    }, []);
    

    return { removeFields, updateField, sortFlatFields, swapFieldOrder };
}
